import { render, staticRenderFns } from "./NonLoginAlertModal.vue?vue&type=template&id=00546210&"
import script from "./NonLoginAlertModal.vue?vue&type=script&lang=ts&"
export * from "./NonLoginAlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports